import { Component } from '@angular/core';
import { convertToISO } from 'app/core/shared/helper/date.helper';
import { isFormChange, onTypeChange } from 'app/core/shared/helper/equipment-registration.helper';
import { FormComponent } from 'app/modules/equipment-registration/component/form-component/form.component';
import { module } from 'app/modules/equipment-registration/equipment-registration.module';
import { Valve } from 'app/modules/equipment-registration/model/valve.model';
import { EquipRegistrationServices } from 'app/modules/equipment-registration/services/equipment-registration.service';

@Component({
  selector: 'app-surface-safety-valve',
  templateUrl: './surface-safety-valve.component.html',
  standalone: true,
  imports: [
    ...module,
    FormComponent
  ],
  styleUrls: ['./surface-safety-valve.component.scss']
})
export class SurfaceSafetyValveComponent {
  public equipmentRegistration$ = this.equipmentServices.equipmentRegistration$
  public ssvForm: Valve = new Valve()
  public tempSsvForm: Valve = new Valve()
  public isReplace: boolean = false;
  public disabledToggle: boolean = true;
  public wellStringId: string

  constructor(
    private equipmentServices: EquipRegistrationServices
  ) { }

  ngOnInit() {
    this.initializeForm()

    this.equipmentRegistration$.subscribe(wellEquipment => {
      if (!wellEquipment) return '';

      this.wellStringId = wellEquipment.wellStringId
     
      if(wellEquipment?.ssValve){
        this.ssvForm = new Valve(wellEquipment?.ssValve);
      } else {
        this.initializeForm()
      }

      this.handleFormValue()
      this.isReplace = !wellEquipment?.ssValve;
      this.disabledToggle = !wellEquipment?.ssValve;
    })
  }

  private initializeForm(): void {
    this.ssvForm.reset()
  }

  private handleFormValue() {
    if (!this.ssvForm.mdSceValveTypeId) {
      this.setSceValveTypeId()
    }

    if (!this.ssvForm.sceXmasTreeId) {
      this.setXmasTreeId()
    }
    
    this.tempSsvForm = new Valve(this.ssvForm)
  }

  private setSceValveTypeId() {
    this.equipmentServices.getSceValveTypeId('SSV').subscribe(id => this.ssvForm.mdSceValveTypeId = id)
  }

  private setXmasTreeId() {
    this.equipmentServices.getSceXmasTreeByStringId(this.wellStringId).subscribe(res => {

      if (res.data) {
        this.ssvForm.sceXmasTreeId = res.data.id
      }
    })
  }

  disabledSave(): boolean {
    return !this.ssvForm.mdSceValveTypeId || !this.ssvForm.sceXmasTreeId || isFormChange(this.ssvForm, this.tempSsvForm) 
  }

  save() {
    onTypeChange(this.ssvForm)

    const operation = this.isReplace ?
      this.equipmentServices.addSceValve(this.ssvForm) :
      this.equipmentServices.updateSceValve(this.ssvForm);

    operation.subscribe((res) => {
      if (res) {
        this.equipmentServices.getEquipmentRegistration(this.wellStringId).subscribe();
      }
    });
  }
}
